<template>
  <section class="popular-products">
    <div class="popular-products-inner">
      <div class="section-header">
        <h2 class="section-title">Popular products</h2>
        <button class="see-more" type="button" @click="$router.push({ name: 'products' })">See more</button>
      </div>
      <div class="products-grid">
        <div v-for="(product, index) in product_list" :key="index" class="product-item"
          @click="toProductDetail(product)">
          <div class="product-image-wrapper">
            <img :src="product.image_url" :alt="product.part_number" class="product-image">
          </div>
          <div class="product-info">
            <div class="product-name">{{ product.part_number }}</div>
            <div class="product-desc">{{ product.name }}</div>
            <div class="product-price">${{ product.price }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PopularProducts',
  data() {
    return {
      product_list: [],
      loading: false
    }
  },
  mounted() {
    this.fetchProducts()
  },
  methods: {
    async fetchProducts() {
      this.loading = true
      try {
        const res = await this.$api({
          url: 'Content/home',
          method: 'get'
        })
        const hotParts = ((res && res.data && res.data.hot_parts) || []).slice(0, 5)
        this.product_list = hotParts
      } catch (err) {
        console.error('Failed to fetch popular products:', err)
      } finally {
        this.loading = false
      }
    },
    toProductDetail(product) {
      this.$router.push({
        name: 'products',
        params: { id: product.id }
      })
    }
  }
}
</script>

<style scoped>
.popular-products {
  width: 100%;
  padding: 0 20px 44px;
  background-color: #fff;
}

.popular-products-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.section-header {
  margin-bottom: 24px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.section-title {
  margin: 0;
  color: #222;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.see-more {
  border: 0;
  background: transparent;
  color: #F34B01;
  cursor: pointer;
  font-size: 13px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
}

.product-item {
  min-width: 0;
  cursor: pointer;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.product-item:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.product-item:hover .product-image {
  transform: scale(1.08);
}

.product-image-wrapper {
  width: 100%;
  aspect-ratio: 1 / 1;
  margin-bottom: 18px;
  overflow: hidden;
  background-color: #f7f7f7;
  border-bottom: 1px solid #e5e5e5;
}

.product-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: transform 0.2s ease;
}

.product-info {
  padding: 0 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.product-name {
  color: #F34B01;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
}

.product-desc {
  color: #999;
  font-size: 13px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-price {
  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
}

@media (max-width: 992px) {
  .products-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 640px) {
  .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
